import { $$ } from "@utils/dom";

import Module from "../module/Module";
import PbRowFeaturedContent from "./PbRowFeaturedContent";

export const SELECTOR = `[data-pb-row-featured-content]`;

class Factory extends Module {
  constructor(init = false) {
    super();

    this.initialized = false;
    this.items = null;

    init ? this.init() : null;
  }

  get name() {
    return "PbRowFeaturedContent";
  }

  init() {
    // set initialized
    this.initialized = true;
    this.items = [...$$(SELECTOR)].map(el => new PbRowFeaturedContent(el, this.emitter));
  }

  destroy() {
    if (this.items) this.items.forEach(el => el.destroy());

    this.initialized = false;
    this.items = null;
  }
}

export default Factory;
